export const theme = {
  font: `'Nunito Sans', sans-serif`,
  secondFont: `'Roboto', sans-serif`,
  fontSize: '18px',
  colors: {
    darkText: '#232324',
    red: '#E0001A',
    redLink: '#ED1C23',
    redLinkButton: 'rgba(237 28 35 / 80%)',
    darkRed: '#D60005',
    heatSignature: '#E3000F',
    redLight: '#ED1C23CC',
    gray: '#707070',
    grayBar: '#2F2F30',
    graySideBar: '#2E2B27',
    grayBackground: '#2f2b27',
    lightGray: '#B3B3B3',
    heavenlyWhite: '#EBE7E6',
    billowyClouds: '#F5F0E9',
    lynxWhite: '#F7F7F7',
    alabaster: '#F9F8F8',
    catskillWhite: '#F5F8FA',
    pink: '#FFD0D1',
    brown: '#694B50',
    green: '#5F7A52',
    blue: '#668CA5',
    white: '#FFFFFF',
    black: '#000',
    focusColor: '#D60005',
    borderColor: '#c3c3c3',
    gallery: '#EFEFEF',
  },
  gap: {
    side: '30px',
  },
  desktop: {
    h1: {
      fontSize: '40px',
      fontWeight: '400',
      lineHeight: '56px',
      lg: {
        fontSize: '56px',
        lineHeight: '66px',
      },
    },
    h2: {
      fontSize: '46px',
      fontWeight: '300',
      lineHeight: '60px',
    },
    h3: {
      fontSize: '40px',
      fontWeight: '300',
      lineHeight: '50px',
    },
    h4: {
      fontSize: '30px',
      fontWeight: '300',
      lineHeight: '40px',
      lg: {
        fontSize: '46px',
        lineHeight: '60px',
      },
    },
    h5: {
      fontSize: '30px',
      fontWeight: '300',
      lineHeight: '50px',
    },
  },
};
